import dayjs from 'dayjs';
import { range } from 'lodash-es';
import { extend } from 'vee-validate';

extend('valid_leap_year', {
  validate(value, { birthdayMonth, birthdayDay }) {
    if (birthdayMonth === '2' && birthdayDay === '29') {
      const year = parseInt(value, 10);

      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    return true;
  },
  params: ['birthdayMonth', 'birthdayDay'],
  message: 'is not a leap year',
});

export default {
  computed: {
    birthdayMonthOptions() {
      return dayjs.months().map((month, i) => ({ id: i + 1, text: month }));
    },
    birthdayDayOptions() {
      if (!this.birthdayMonth) {
        return [];
      }

      // Use 2020 leap year, to get the correct number of days in the February
      const days = dayjs('2020-02-29')
        .month(this.birthdayMonth - 1)
        .daysInMonth();

      return Array.from({ length: days }, (_, i) => i + 1);
    },
    birthdayYearOptions() {
      if (!this.birthdayDay) {
        return [];
      }

      return range(new Date().getFullYear(), 1906);
    },
    memberAge() {
      const birthday = dayjs(`${this.birthdayYear}-${this.birthdayMonth}-${this.birthdayDay}`);
      const age = dayjs().diff(birthday, 'year');

      return `${age} ${age === 1 ? 'year' : 'years'} old`;
    },
  },
};
